export default function SkillsPage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Skills</h1>
      <p className="text-gray-500">Skill verification and management - coming soon</p>
    </div>
  )
}
